import { IntakePayloadSchema } from 'fido-types';
import { z } from 'zod';

export type IntakePayload = z.infer<typeof IntakePayloadSchema>;

export const IntakeBootstrapResponseSchema = z.strictObject({
  token: z.string(),
  sessionId: z.string(),
  expiresAt: z.number(),
  firmSlug: z.string(),
  firmWebsiteUrl: z.string().nullish(),
  firmName: z.string(),
  includeSituations: z.boolean(),
  includeMatters: z.boolean(),
  includeQualifiers: z.boolean(),
  includeUrgency: z.boolean(),
});
